<!-- <p-dropdown style="min-height: 300; min-width: 200;" [options]="operators" [(ngModel)]="selectedOperator" optionLabel="name"></p-dropdown> -->




<p-dropdown *ngIf="show" [options]="operators" [(ngModel)]="selectedOperator" optionLabel="name" [filter]="true" filterBy="name" [showClear]="true" placeholder="Select an operator">
  <ng-template pTemplate="selectedItem">
      <div class="country-item country-item-value"  *ngIf="selectedOperator">
          <!-- <img src="assets/showcase/images/demo/flag/flag_placeholder.png" [class]="'flag flag-' + selectedOperator.code.toLowerCase()" /> -->
          <div>{{selectedOperator.name}}</div>
      </div>
  </ng-template>
  <ng-template let-country pTemplate="item">
      <div class="country-item">
          <!-- <img src="assets/showcase/images/demo/flag/flag_placeholder.png" [class]="'flag flag-' + country.code.toLowerCase()" /> -->
          <div>{{country.name}}</div>
      </div>
  </ng-template>
</p-dropdown>